import { useContext } from "react";
import useEmpMasters from "../customHooks/useEmpMasters";
import Input from "../stories/Input/Input";
import { AppContext } from "../context/context";
import { EMPTY_STRING } from "../utils/constants";

const LoggedEmployee = () => {
  const { state } = useContext(AppContext);
  const { data } = useEmpMasters(state.empId);

  return <Input disabled value={data ? `${data.node.name} ` : EMPTY_STRING} />;
};

export default LoggedEmployee;
